import axios from 'axios';

const generateReport = (idComprador, data) => axios.post(`/fornecedores/relatorios/compradores/${idComprador}/geracao`, data);

export default {
  generateReport,
};
